import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="sidebar-nav">
      <div className="brand-area">
        <Link className="navbar-brand" to="/">
          <i className="bi bi-briefcase-fill text-accent display-4 mb-3 d-block"></i>
          <span className="brand-text">NEVIS<br/>TRUST</span>
        </Link>
      </div>
      
      <div className="nav-links">
        <NavLink className="nav-item" to="/" end>Home</NavLink>
        <NavLink className="nav-item" to="/about">About</NavLink>
        <NavLink className="nav-item" to="/services">Services</NavLink>
        <NavLink className="nav-item" to="/contact">Contact</NavLink>
      </div>

      <div className="nav-footer">
        <Link to="/contact" className="btn btn-accent w-100">
          Consult
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
